import React from 'react';
import { Button, MainLayout, Triptych } from '@app/components';
import { PaymentProviderList, PaymentProviderDeleteModal, PaymentProviderCreate, PaymentProviderUpdate } from '@app/features/PaymentProvider';
import { useResourceScreenHelpers } from '@app/hooks';
import { paymentProviderApi } from '@app/store';
import { IPaymentProvider } from '@app/common';
import { SettingHeader } from '@app/features/SettingHeader';
import { CheckPermissions } from '@app/components/CheckPermissions';

export const PaymentProviderScreen = () => {
  const [readOne, { isFetching }] = paymentProviderApi.useLazyReadOnePaymentProvidersQuery();
  const [deleteOne, { isLoading }] = paymentProviderApi.useDeleteOnePaymentProvidersMutation();

  const { triptych, modal, onDelete, onUpdate, mode, selectedItem, item: paymentProvider } = useResourceScreenHelpers<IPaymentProvider>();

  const openCard = async (item: Partial<IPaymentProvider>) => {
    onUpdate(readOne({
      filters: { _id: { $eq: item?._id } },
    }), item)
  }

  return (
    <MainLayout
      header={(
        <SettingHeader>
          <CheckPermissions permissions={['dashboard::payment-providers.create']}>
            <Button
              onPress={() => triptych.open({ mode: 'CREATE' })}
              title='Ajouter un prestataire de paiement' />
          </CheckPermissions>
        </SettingHeader>
      )}>

      <PaymentProviderDeleteModal
        {...modal}
        onDelete={(paymentProvider) => onDelete(deleteOne(paymentProvider._id!))}
        isLoading={isLoading} />

      <Triptych
        list={(
          <PaymentProviderList
            selectedRowItem={selectedItem}
            onRowPress={(item) => triptych.close({ data: item, mode: 'UPDATE' })}
            onUpdate={openCard}
            onDelete={modal.open} />
        )}
        form={(
          mode === 'CREATE'
            ? <PaymentProviderCreate />
            : <PaymentProviderUpdate
              paymentProvider={paymentProvider ?? selectedItem}
              toggle={(mode) => mode === 'UPDATE' ? openCard(selectedItem) : triptych.close()}
              isFetching={isFetching}
              onDelete={modal.open} />
        )} />
    </MainLayout>
  );
};

